import { Dispatch } from 'redux';
import { ExerciseTypes } from './types';
import { ApiEndpoints, ActionHandler } from 'Utils';

export const GetAllExercises = (devId:string) => (dispatch: Dispatch) => {

	const id = localStorage.getItem('currentChildId');
	const newUrl = ApiEndpoints.getAllExercises + `/${id}` + `/${devId}`;
	return ActionHandler(
		{ url: newUrl, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: ExerciseTypes.LOAD_ALL_EXERCISE, payload: data });
		},
		error => {
			dispatch({ type: ExerciseTypes.LOAD_EXERCISE_FAIL, payload: { errors: error } });
		},
	);
};

export const GetExerciseById = (id: string) => (dispatch: Dispatch) => {
	const newUrl = ApiEndpoints.exerciseDetails + `/${id}`
	return ActionHandler(
		{ url: newUrl, method: 'GET', dispatch },
		res => {
			const { data } = res.data;
			dispatch({ type: ExerciseTypes.LOAD_EXERCISE_BY_ID, payload: data });
		},
		error => {
			dispatch({ type: ExerciseTypes.LOAD_EXERCISE_FAIL, payload: { errors: error } });
		},
	);
};
